<template>
  <div class="mdc-layout-grid__inner" id="courses">
    <div class="mdc-layout-grid__cell--span-12">
      <div class="Courses">
        <h1 style="margin: 20px">Titulo de pagina de cursos</h1>
      </div>
      <States />
    </div>
  </div>
</template>



<script>
import States from '@/components/States.vue'

export default {
  name: 'Courses',
  components: {
    States,
  },
  data() {
    return {
      switch_is_checked: false,
      emit_method: '_get_switch_value',
    };
  },
  computed: {
  },
  methods: {
    _getValueFromSwitch(switch_value) {
      this.switch_is_checked = switch_value;
    },
  },
}
</script>



<style lang="scss" scoped>
  .Courses p {color:blue}
</style>
